export default __webpack_public_path__ + "static/media/tropicana-middle-2.130db77d.png";